export const CLUB = {
  name: 'Zanshin Karaté Club',
  tagline: 'Dojo familial affilié FFKaraté — Castelnau d’Estrétefonds',
  address: ['Complexe Sportif Fondada', '1423 Rte de Villeneuve-lès-Bouloc', '31620 Castelnau d’Estrétefonds'],
  phone: '07 68 16 62 23',
  phoneHref: 'tel:+33768166223',
  email: 'giovanny.lauret@live.fr',
  helloAsso: 'https://www.helloasso.com/',
  logo: 'https://cdn.magicpatterns.com/uploads/ahUUsto47LNCdWtc9dvz2u/brk-52b39873-2cb4-46fa-93f1-03864a4bf18a.png',
}

export const NAV = [
  { label: 'Accueil', to: '/' },
  { label: 'Le Club', to: '/le-club' },
  { label: 'Informations pratiques', to: '/informations-pratiques' },
  { label: 'Calendrier', to: '/calendrier' },
  { label: 'Partenaires', to: '/partenaires' },
  { label: 'Contact', to: '/contact' },
]

export const SOCIALS = [
  { label: 'Facebook', href: 'https://facebook.com' },
  { label: 'Instagram', href: 'https://instagram.com' },
  { label: 'TikTok', href: 'https://tiktok.com' },
  { label: 'YouTube', href: 'https://youtube.com' },
]

export const HERO = {
  kanji: '残心',
  quote:
    '« La technique parfaite n’est rien si l’esprit n’est pas présent à chaque instant. »',
  quoteAuthor: 'Hidetaka Nishiyama — Maître Shotokan international',
  intro:
    'Bienvenue au Zanshin Karaté Club, votre dojo familial en Occitanie, à Castelnau d’Estrétefonds (à 20 min de Toulouse). Ancré dans la tradition japonaise et tourné vers l’excellence, notre club transmet la passion du karaté à tous les âges. Du pratiquant loisir au compétiteur international, nous cultivons la rigueur, l’esprit de famille et le dépassement de soi.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ee60ec19-ac7d-44c5-bebb-1d77964941a3.jpg',
}

export const KEY_FIGURES = [
  { value: '2008', label: 'Année de création' },
  { value: '+50', label: 'Adhérents licenciés' },
  { value: '2', label: 'Enseignants diplômés d’État' },
  { value: 'Dès 7 ans', label: 'Ouvert aux enfants' },
  { value: '1', label: 'Préparateur mental diplômé' },
]
